import Env from 'root/lib/Env';
// import MEASURE_IDS from 'a/placementTool/data/measureIds';
import gameIds from '../hub/data/GameIds';

export const MEASURE_ID = 'measure.letter_sound_correspondences';
export const GAME_ID = gameIds.LETTER_SOUND_CORRESPONDENCES;

const CONTENT_URL = `${Env.GAME_CONTENT_URL}/${MEASURE_ID}`;
export const CURRICULUM_URL = `${CONTENT_URL}/curriculum/`;
export const CURRICULUM_COHORTS_URL = `${Env.GAME_CONTENT_URL}/${GAME_ID}/cohorts/`;
export const LETTERS_URL = `${CONTENT_URL}/audio/spa-es-default`;
export const QUESTIONS_PER_LEVEL = 10;

export const SCREENS = {
  LOADING: 'letter sound correspondences: loading',
  ONBOARDING: 'letter sound correspondences: onboarding',
  STANDARD: 'letter sound correspondences: standard',
};

export const THEME = {
  LIGHT_PURPLE: '#f2efff',
  PURPLE: '#9C99FF',
  WHITE: '#ffffff',
  BLACK: '#000000',
};

export const AVATAR_STATES = {
  IDLE: 'IDLE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INSTRUCTING: 'INSTRUCTING',
  SPEAKING: 'SPEAKING',
  ENCOURAGING: 'ENCOURAGING',
};
